"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPrompt = void 0;
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var LoginPromptClass = /** @class */ (function (_super) {
    __extends(LoginPromptClass, _super);
    function LoginPromptClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            username: '',
            password: ''
        };
        _this.handleInputChanged = function (event) {
            var _a;
            return _this.setState((_a = {}, _a[event.target.name] = event.target.value, _a));
        };
        _this.handleFormSubmit = function (event) {
            var _a, _b;
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (_b = (_a = _this.props).onSendData) === null || _b === void 0 ? void 0 : _b.call(_a, {
                type: 'login_prompt',
                text: 'Provided login information',
                username: _this.state.username,
                password: _this.state.password,
                sensitive: ['password']
            });
            event.preventDefault();
        };
        return _this;
    }
    LoginPromptClass.prototype.render_bot_active = function () {
        var userName = this.props.intl.formatMessage({
            id: 'loginForm.userName',
            defaultMessage: 'Username'
        });
        var password = this.props.intl.formatMessage({
            id: 'loginForm.password',
            defaultMessage: 'Password'
        });
        var submit = this.props.intl.formatMessage({
            id: 'loginForm.submit',
            defaultMessage: 'Submit'
        });
        return (react_1.default.createElement("form", { className: 'bpw-form-container', onSubmit: this.handleFormSubmit },
            react_1.default.createElement("label", null,
                react_1.default.createElement("input", { id: "login_username", type: "input", name: "username", placeholder: userName, className: "bpw-input", onChange: this.handleInputChanged })),
            react_1.default.createElement("label", null,
                react_1.default.createElement("input", { id: "login_password", type: "password", name: "password", placeholder: password, className: "bpw-input", onChange: this.handleInputChanged })),
            react_1.default.createElement("input", { id: "login_submit", className: 'bpw-button-alt', type: "submit", value: submit })));
    };
    LoginPromptClass.prototype.render_bot_past = function () {
        var formTitle = this.props.intl.formatMessage({
            id: 'loginForm.formTitle',
            defaultMessage: 'Login form'
        });
        return (react_1.default.createElement("div", { className: 'bpw-special-action' },
            react_1.default.createElement("p", null,
                "* ",
                formTitle,
                " *")));
    };
    LoginPromptClass.prototype.render_user = function () {
        var providedCredentials = this.props.intl.formatMessage({
            id: 'loginForm.providedCredentials',
            defaultMessage: 'Login form'
        });
        return (react_1.default.createElement("div", { className: 'bpw-special-action' },
            react_1.default.createElement("p", null,
                "* ",
                providedCredentials,
                " *")));
    };
    LoginPromptClass.prototype.render = function () {
        if (!this.props.isBotMessage) {
            return this.render_user();
        }
        if (this.props.isLastMessage) {
            return this.render_bot_active();
        }
        return this.render_bot_past();
    };
    return LoginPromptClass;
}(react_1.Component));
exports.LoginPrompt = (0, react_intl_1.injectIntl)(LoginPromptClass);
